export const urlParams = new URLSearchParams(window?.location?.search.substring(1) || '');
